import { useMemo } from "react";
import { GetMissingFieldsLevelParameter } from "@wingspanhq/wingspan-api-sdk";
import { queriesOnboarding } from "@query";

export const useMissingData = (verificationLevel: string) => {
  const queryMissingDataTax = queriesOnboarding.getMissingFields.useQuery({
    level: GetMissingFieldsLevelParameter.TAX
  });
  const queryMissingDataBanking = queriesOnboarding.getMissingFields.useQuery({
    level: GetMissingFieldsLevelParameter.BANKING
  });

  return useMemo(
    () =>
      verificationLevel === "Tax"
        ? queryMissingDataTax.data
        : queryMissingDataBanking.data,
    [queryMissingDataBanking.data, queryMissingDataTax.data, verificationLevel]
  );
};
